export default function UserActivitySkeleton({
  count = 7,
}: {
  count?: number;
}) {
  return (
    <div className="px-0">
      {/* Timeline Skeleton */}
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="flex items-start gap-4 mb-6 animate-pulse">
          {/* Timeline dot */}
          <div className="w-4 flex flex-col items-center pt-2">
            <div className="w-3 h-3 bg-gray-300 rounded-full" />
            <div className="w-0.5 flex-1 bg-gray-200 mt-1" />
          </div>
          {/* Timeline content */}
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-1">
              <div className="h-5 w-20 bg-gray-200 rounded" />
              <div className="h-4 w-32 bg-gray-100 rounded" />
            </div>
            <div className="h-4 w-40 bg-gray-200 rounded mb-2" />
            <div className="h-3 w-3/4 bg-gray-100 rounded mb-1" />
            <div className="h-3 w-1/2 bg-gray-100 rounded" />
          </div>
        </div>
      ))}
    </div>
  );
}
